const theme = Object.freeze({
  colors: {
    primaryLight: '#ffffff',
    primaryDark: '#2F2F2F',
    primaryAccent: '#407BFF',

    secondaryLight: '#ECF2FF',
    secondaryLightBlue: '#D7E3FF',
    secondaryBlue: '#9EBBFF',
    secondaryRed: '#EF5050',
    secondaryYellow: '#FF9D43',
    secondaryGray: '#8F8F8F',
  },
  fontSizes: {
    tiny: '12px',
    small: '16px',
    medium: '18px',
    large: '26px',
    XL: '28px',
  },

  animation: {
    duration: '0.3s',
    cubicBezier: '0.25s cubic-bezier(0.7, 0.98, 0.86, 0.98)',
  },
});

export default theme;
